import { render, staticRenderFns } from "./EventTimeline.vue?vue&type=template&id=0fb8b326&scoped=true&"
import script from "./EventTimeline.vue?vue&type=script&lang=ts&"
export * from "./EventTimeline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb8b326",
  null
  
)

export default component.exports